<template>
    <div>
        <div class="my-title">
            <img src="https://img.yzcdn.cn/vant/logo.png" class="my-img"/>
            工会服务
        </div>
        <div class="my-body">
            <div class="my-box" v-for="(v,i) in boxArr" :key="i" @click="to(v)">
                <div>
                    <icon v-if="v.icon != 'gzzn'" :name="v.icon" size="40" color="#c60001"/>
                    <img v-if="v.icon == 'gzzn'" src="../assets/gzzn.png" class="gzzn"/>
                </div>
                <span  style="font-size: 0.6rem">{{v.label}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {Icon} from 'vant'
    import service from "../api/service";

    export default {
        components: {
            Icon
        },
        name: "homeList",
        data() {
            return {
                boxArr: [],//腰部栏目
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            to(v) {
                if(v.path == '/employeeAppeal' && !sessionStorage.getItem("openid"))
                {
                    this.$toast('请先登录！')
                    setTimeout(()=>
                    {
                        this.$router.push({path: '/personalCenter'})
                    },1000)
                    return;
                }

                this.$store.state.detailList = v
                this.$router.push({path: v.path,query:v})
            },
            init() {
                service.get('/api/xw/topTitleBar', {position: '腰部栏目'}).then(res => {
                    if (res.status === 200) {
                        let arr = []
                        res.data.forEach(v => {
                            arr.push({
                                label: v.xwName,
                                id: v.id,
                                icon: v.icon,
                                bacImg: v.bacImg,
                                path: '/detailList',
                            })
                        })
                        arr.push({
                            icon: 'manager',
                            label: '职工诉求',
                            path: '/employeeAppeal'
                        })
                        this.boxArr = arr
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .gzzn{
        width: 40px;
        height: 40px;
    }
    .my-title {
        height: 40px;
        background-color: #c60001;
        color: #ffffff;
        display: flex;
        align-items: center;
        margin: 0.5rem 0;

    }

    .my-body {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .my-box {
        text-align: center;
        color: #c60001;
        font-size: 0.24rem;
        margin: 10px;
    }

    .my-img {
        width: 1rem;
        margin: 0 .5rem;
        filter: grayscale(100%) brightness(200%);
    }
</style>